import { useParams, useLocation } from "react-router-dom";
import { useDatabase } from "../../hooks/useDatabase";
import { useEffect } from "react";

import { SkillList, SkillType } from "../../components/SkillScroller/Skill";
import WorkPagination from "../../components/WorkPagination/WorkPagination";

import ErrorPage from "./../ErrorPage";

import './WorkItem.css';

export interface WorkItem {
    id: number;
    handle: string;
    title: string;
    tags: string[];
    content: string;
    images: {
        url: string;
        alt: string;
        caption: string;
    }[];
    videos: {
        url: string;
        caption: string;
    }[]
}

export default function WorkItem() {
    const params = useParams();
    const db = useDatabase();
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    if (!params || !params.handle) return <ErrorPage />;

    const workItems: WorkItem[] = db.sections.work as WorkItem[];

    const workItem: WorkItem | undefined = workItems.find(w => w.handle === params.handle);

    if (!workItem) return <ErrorPage />;

    const tags: Array<keyof SkillType> = workItem.tags;

    return (<div className="page-container">
        <section className="work-hero">
            <div className="inner">
                <div className="cols span-2">
                    <div className="col">
                        <h1>{workItem.title}</h1>
                        <div className="icon-list">
                            {workItem.tags.map((tag) => {
                                const skill = SkillList[tag];
                                return skill ? (<div className="icon" key={tag}>{skill.component}</div>) : null;
                            })}
                        </div>
                        <div className="work-content" dangerouslySetInnerHTML={{ __html: workItem.content }}></div>
                    </div>
                    <div className="col">
                        <img src={workItem.images[0].url} alt={workItem.images[0].alt} />
                    </div>
                </div>
            </div>
        </section>

        {workItem.images.map((v, i) => {
            return <section className="work-image" key={i}>
                <div className="inner">
                    {v.caption === null ? <div className="cols no-caption">
                        <div className="col">
                            <img src={v.url} alt={v.alt} />
                            <h3>{v.alt}</h3>
                        </div>
                    </div> : <div className="cols span-2">
                        <div className="col">
                            <h3>{v.alt}</h3>
                            <div className="work-item-caption" dangerouslySetInnerHTML={{ __html: v.caption }}></div>
                        </div>
                        <div className="col">
                            <img src={v.url} alt={v.alt} />
                        </div>
                    </div>}
                </div>
            </section>
        })}

        {workItem.videos.map((v, i) => {
            return <section className="work-video" key={i}>
                <div className="inner">
                    <div className="cols no-caption">
                        <div className="col">
                            <video src={v.url} muted autoPlay playsInline controls></video>
                            <div className="work-item-caption" dangerouslySetInnerHTML={{ __html: v.caption }}></div>
                        </div>
                    </div>
                </div>
            </section>
        })}


        <WorkPagination currentWorkItem={workItem} workItems={workItems} />
    </div>);
}